import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { openedTasksComponent2 } from './openedTasks2.component';


@NgModule({
    declarations: [openedTasksComponent2],
    imports: [CommonModule, RouterModule],
    exports: [openedTasksComponent2]
})

export class OpenedTasksModule2 { }